export enum InformationInputType {
  string = 'string',
  boolean = 'boolean',
  integer = 'integer',
  media = 'media',
  appliance = 'appliance',
  applianceTag = 'appliance_tag',
}

export enum SeverityType {
  monitor = 'monitor',
  repair = 'repair',
  safety = 'safety',
}
